import React, { Component } from "react";
import { connect } from "react-redux";

import * as channelActions from "../../channel/channel.actions";
import { getTopSellers } from "../../channel/channel.selectors";
import Table from "../../common/components/Table";

class BestSellersBlock extends Component {
  componentWillMount = () => {
    const { getTopSellers } = this.props;
    getTopSellers();
  };

  renderScoreRow = item => {
    const { _id, score } = item;
    let { name } = item;
    if (!name) {
      name = item.email;
    }

    return (
      <tr key={_id}>
        <td>{name}</td>
        <td>{score} p</td>
      </tr>
    );
  };

  render() {
    const { topSellers } = this.props;

    return topSellers && topSellers.length > 0 ? (
      <Table
        items={topSellers.slice(0, 5)}
        renderItem={this.renderScoreRow}
        widths={["75%", "25%"]}
      />
    ) : (
      <p>Ei vielä myyntejä.</p>
    );
  }
}

const mapStateToProps = state => {
  const topSellers = getTopSellers(state);
  return {
    topSellers
  };
};

const ConnectedBestSellersBlock = connect(mapStateToProps, Object.assign({}, channelActions))(
  BestSellersBlock
);

export default ConnectedBestSellersBlock;



// WEBPACK FOOTER //
// ./src/modules/team/components/BestSellersBlock.js